import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IExportRequest } from "interfaces/export-duck";
import { requestErrorHandler } from "utils";
import { ExportPickingsLogActions } from "store/ducks/pickings";

export function* exportPickingsLogRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IExportRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/pickings-logs?${queryString}`);
    yield put(ExportPickingsLogActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ExportPickingsLogActions.failure(errorMessage));
  }
}